export default __webpack_public_path__ + "static/media/OM.dade83ef.svg";